import React from 'react'
import './ATCommentBox.css'
import { useTranslation } from 'react-i18next'
interface ATCommentBoxProps {
  message: string
}
const ATCommentBox: React.FC<ATCommentBoxProps> = ({ message }) => {
  const { t } = useTranslation(['translation'])
  return (
    <div className="container my-3">
      <div className="message-label mb-2">{t('common.comment')}:</div>
      <div className="message-box">{message}</div>
    </div>
  )
}

export default ATCommentBox
